import api from "../services/api";

const service_path = "/notifications.php";

export function getNotifications(params = {}) {
    const clean = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const qs = new URLSearchParams(clean).toString();
    const url = qs ? `${service_path}?${qs}` : service_path;
    return api.get(url);
}

export function markNotificationRead(id) {
    return api.patch(service_path, { id });
}

export function markAllNotificationsRead() {
    return api.patch(service_path, { mark_all: true });
}
